module.exports = __webpack_public_path__ + "static/media/trash-undo-alt.7de25635.svg";